export const getVisibleImages = (data) => {
    return data?.filter(images => images?.isVisible); 
}
